import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API, apiError } from "@/lib/api";
import { Smartphone, CheckCircle2, XCircle, Loader2, ShieldAlert } from "lucide-react";

const inr = (n) => "₹" + (n || 0).toLocaleString("en-IN");

export default function MockGateway() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("orderId");
  const [order, setOrder] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { axios.get(`${API}/public/fees/order/${orderId}`).then((r) => setOrder(r.data)).catch(() => setOrder(false)); }, [orderId]);

  const complete = async (outcome) => {
    setBusy(true);
    try {
      await axios.post(`${API}/public/fees/mock/complete`, { merchant_order_id: orderId, outcome });
      navigate(`/pay/result?orderId=${orderId}`);
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); setBusy(false); }
  };

  if (order === false) return <div className="py-24 text-center"><p className="text-slate-600">Order not found.</p><Link to="/" className="pub-btn mt-4">Home</Link></div>;
  return (
    <div className="flex min-h-[80vh] items-center justify-center bg-[#5F259F] px-5" data-testid="mock-gateway">
      <div className="w-full max-w-sm overflow-hidden rounded-3xl bg-white shadow-2xl">
        <div className="bg-[#5F259F] px-6 pb-8 pt-6 text-white">
          <div className="flex items-center gap-2 text-lg font-bold"><Smartphone size={20} /> PhonePe <span className="rounded-full bg-amber-400 px-2 py-0.5 text-[10px] font-bold text-amber-950">SIMULATED · MOCK</span></div>
          <p className="mt-4 text-xs opacity-80">Paying to</p>
          <p className="font-semibold">{order?.school_code} · School Fees</p>
          <p className="mt-3 text-4xl font-bold font-head" data-testid="mock-amount">{order ? inr(order.amount) : <Loader2 className="animate-spin" />}</p>
          <p className="mt-1 font-mono text-[11px] opacity-70">{orderId}</p>
        </div>
        <div className="space-y-3 p-6">
          <p className="flex items-start gap-2 rounded-xl bg-amber-50 px-3 py-2 text-xs text-amber-800"><ShieldAlert size={14} className="mt-0.5 shrink-0" /> No real money moves. This page simulates PhonePe checkout until the school's PhonePe credentials are connected by the Super Admin.</p>
          <button className="pub-btn w-full !bg-emerald-600 hover:!bg-emerald-700" onClick={() => complete("success")} disabled={busy || !order || order.state === "COMPLETED"} data-testid="mock-pay-success"><CheckCircle2 size={16} /> Simulate successful payment</button>
          <button className="pub-btn pub-btn-outline w-full !text-rose-600" onClick={() => complete("failure")} disabled={busy || !order || order.state === "COMPLETED"} data-testid="mock-pay-fail"><XCircle size={16} /> Simulate failed payment</button>
        </div>
      </div>
    </div>
  );
}
